/**
 * Renders the global playbar
 */

import React from 'react';
import { observer } from 'mobx-react';

const ProgressBar = observer(class ProgressBar extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      progress: 0
    };

    // Set up refs
    this.progressBar = React.createRef();
  }

  componentDidMount() {
    const { current, duration } = this.props;
    
    if (current && duration) {
      this.updateProgress(current / duration * 100);
    }
  }

  componentDidUpdate(prevProps) {
    const { current, duration } = this.props;

    // Update progress
    if (prevProps.current !== current) {
      this.updateProgress(current / duration * 100)
      // this.checkFlags();
    }
  }

  updateProgress(progress) {
    this.setState({
      progress
    });
  }

  checkFlags() {
    const { current, flags, onFlag, onPlay } = this.props;
    const { AppStore, PlayerStore } = this.props.store;

    const currentFlags = flags.filter(flag => {
      return current >= flag.sessionTime && flag.status === 'pending review' && flag.severity !== 'green'
    });

    if (currentFlags.length) {
      // Pause playback
      onPlay();

      if (onFlag) {
        onFlag(true);
      }

      // Show the review toaster
      PlayerStore.checkFlag(currentFlags[0], onFlag);
    } else if (AppStore.toast) {
      AppStore.dismissToast();
    }
  }

  handleClick(e) {
    const { duration, onSeek, readOnly } = this.props;

    if (e.pageX === 0 || readOnly) {
      return;
    }

    const progressBar = this.progressBar.current;

    const width = progressBar.offsetWidth;
    const x = e.pageX - progressBar.offsetLeft;
    const percentage = x / width;

    onSeek(duration * percentage);
  }

  render() {
    const { className, duration, flags, highlights, readOnly, store } = this.props;
    const { progress } = this.state;
    const { hideInfoFlags } = store.PlayerStore;

    return (
      <div
        className={`progress-bar ${className ? className : ''}`}
        onMouseDown={(e) => this.handleClick(e)}
        onDragStart={(e) => {
          if (readOnly) {
            return;
          }

          const img = new Image();
          img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
          img.style.visibility = 'hidden';
          e.dataTransfer.setDragImage(img, 0, 0);
        }}
        onDrag={(e) => this.handleClick(e)}
        onClick={(e) => this.handleClick(e)}
        ref={this.progressBar}
        draggable="true"
      >
        <div
          className="progress-bar__progress"
          style={{ width: `${progress}%` }}
          draggable="false"
        >
          {progress}%
        </div>

        {/* Highlight segments (room scan, exam, etc.) */}
        {highlights && highlights.map((highlight, i) =>
          <div
            key={i}
            className={`progress-bar__highlight ${highlight.type}`}
            style={{
              left: `${highlight.start / duration * 100}%`,
              width: `${(highlight.end - highlight.start) / duration * 100}%`
            }}
          >
            <span className="progress-bar__tooltip">{highlight.title}</span>
          </div>
        )}

        {/* Show flags */}
        {flags && flags.map(
          (flag, i) => {
            if (
              (hideInfoFlags && flag.severity !== 'green') ||
              !hideInfoFlags
            ) {
              return (
                <div
                  key={i}
                  className={
                    `progress-bar__tick progress-bar__tick--${flag.severity} ${flag.status ? flag.status : ''}`
                  }
                  style={{
                    left: `${flag.sessionTime / duration * 100}%`,
                  }}
                >
                  <span className="progress-bar__tooltip">{flag.title}</span>
                </div>
              );
            }

            return null;
          }
        )}
      </div>
    )
  }
})

export default ProgressBar;